export const loadFixedRouteErrors = [
  "FixedRouteNotFound",
  "StopHasNoLocation",
  "UserPreferencesNotFound",
] as const;

export const changeVisitDurationErrors = ["VisitDoesNotExist"];
export const descheduleVisitErrors = ["VisitDoesNotExist"];
export const scheduleVisitErrors = ["VisitAlreadyExists", "VisitDescheduled"];
